import { takeLatest, put } from 'redux-saga/effects'
//import { push } from 'react-router-redux'
import * as CONST from 'Reducers/Roster/const'
import * as ERRORS from 'Reducers/Errors/const'
import { apiClient } from 'Module/API/Client'
import NProgress from 'nprogress'
import { findIndex } from 'lodash'

import { callApi } from 'Reducers/apiCall'
import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'

/**
 * Create roster
 *
 * @param action
 */
function* createRoster(action) {
  const { callbacks, cityPlanId, payload } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  const response = yield callApi(apiClient.createRoster, payload, cityPlanId)
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.CREATE_ROSTER_SUCCESS,
    })
    callbacks.onSuccess(responseJson)
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Update roster
 *
 * @param action
 */
function* updateRoster(action) {
  const { callbacks, rosterId, payload } = action

  NProgress.start()

  const response = yield callApi(apiClient.updateRoster, payload, rosterId)
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.UPDATE_ROSTER_SUCCESS,
      payload: {
        rosterById: responseJson,
      },
    })
    callbacks.onSuccess(responseJson)
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }

  NProgress.done()
}

/**
 * Delete roster by id
 *
 * @param action
 */
function* deleteRosterById(action) {
  NProgress.start()

  try {
    const response = yield callApi(apiClient.deleteRosterById, action.rosterId)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.DELETE_ROSTER_BY_ID_SUCCESS,
      })
      //yield put(push(action.callbackPath))
      // TODO: Can replace this once PAD-1344 is done, this is needed to ensure
      // data is consistent while we in a half-way house with a refactor
      window.location = action.callbackPath
    } else {
      yield put({
        type: CONST.DELETE_ROSTER_BY_ID_ERROR,
        errorMessage: responseJson.message,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Get roster by id
 *
 * @param action
 */
function* getRosterById(action) {
  NProgress.start()

  try {
    const response = yield callApi(apiClient.getRosterById, action.rosterId)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_ROSTER_BY_ID_SUCCESS,
        payload: {
          rosterById: responseJson,
        },
      })
    } else {
      yield put({
        type: CONST.GET_ROSTER_BY_ID_ERROR,
        payload: {
          errorMessage: responseJson.message,
        },
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Get rosters by cityid
 *
 * @param action
 */
function* getRostersByCityId(action) {
  NProgress.start()

  try {
    const response = yield callApi(apiClient.getRostersByCityId, action.cityId)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_ROSTERS_BY_CITY_ID_SUCCESS,
        payload: {
          rostersByCityId: responseJson,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Update mission data and refresh rosters missions list
 *
 * @param action
 */
function* updateRostersMission(action) {
  const { id, payload } = action

  NProgress.start()

  try {
    const response = yield callApi(apiClient.updateMission, id, payload)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.UPDATE_ROSTERS_MISSION_SUCCESS,
        payload: responseJson,
        id,
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Get client's rosters by cities
 *
 * @param action
 */
function* getClientRostersByCities(action) {
  NProgress.start()
  yield put(incUIBlockCounter())

  try {
    const response = yield callApi(apiClient.getRosters)
    const responseJson = yield response.json()

    if (response.ok) {
      let clientRostersByCities = []

      responseJson.map(roster => {
        const cityId = roster.cityPlan.city.id
        const cityName = roster.cityPlan.city.name
        const currentIndex = findIndex(clientRostersByCities, { cityId })

        if (currentIndex > -1) {
          clientRostersByCities[currentIndex].rosters.push(roster)
        } else {
          clientRostersByCities.push({
            cityId,
            cityName,
            rosters: [roster],
          })
        }

        return null
      })

      yield put({
        type: CONST.GET_CLIENT_ROSTERS_BY_CITIES_SUCCESS,
        payload: {
          clientRostersByCities,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Create roster request watcher
 */
export function* watchCreateRoster() {
  yield takeLatest(CONST.CREATE_ROSTER, createRoster)
}

/**
 * Update roster request watcher
 */
export function* watchUpdateRoster() {
  yield takeLatest(CONST.UPDATE_ROSTER, updateRoster)
}

/**
 * Get roster by id watcher
 */
export function* watchGetRosterById() {
  yield takeLatest(CONST.GET_ROSTER_BY_ID, getRosterById)
}

/**
 * Get rosters by city plan id watcher
 */
export function* watchGetRostersByCityId() {
  yield takeLatest(CONST.GET_ROSTERS_BY_CITY_ID, getRostersByCityId)
}

/**
 * Delete roster by id watcher
 */
export function* watchDeleteRosterById() {
  yield takeLatest(CONST.DELETE_ROSTER_BY_ID, deleteRosterById)
}

/**
 * Update mission data and refresh rosters missions list watcher
 */
export function* watchUpdateRostersMission() {
  yield takeLatest(CONST.UPDATE_ROSTERS_MISSION, updateRostersMission)
}

/**
 * Get client's rosters by cities watcher
 */
export function* watchGetClientRostersByCities() {
  yield takeLatest(CONST.GET_CLIENT_ROSTERS_BY_CITIES, getClientRostersByCities)
}



// WEBPACK FOOTER //
// ./src/Reducers/Roster/sagas.js